module.exports = __webpack_public_path__ + "img/logo_secanda_tiny.a8da5127.png";